import { HintsValidationComponent } from 'shared/hints/hints-validation/hints-validation.component';
import { CommentsComponent } from 'shared/comments/comments.component';


export const rightPanelNavs: any[] = [
  {
    title: 'Hints',
    name: 'hints',
    active: true,
    component: HintsValidationComponent,
  }
];
